import { Customer } from './test/customer.model';
import { InvoiceComponent } from './invoice/invoice.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from "@angular/router";

import { AuthGuardService } from './service/auth-guard-service';
import { DeliveryOptionComponent } from './delivery-option/delivery-option.component';
import { ProductComponent } from './product/product.component';
import { CustomerComponent } from './customer/customer.component';
import { LoginComponent } from './login/login.component';
import { QuoteComponent } from './quote/quote.component';
// import { ReportComponent } from './report/report.component';

const routes: Routes = [
  {
   path: "",
   redirectTo: "customer", // temporarily, we will not have it navigate. Eventually, we will probably have it navigate to customers
   pathMatch: "full",
   canActivate: [AuthGuardService]
 },
 {
  path: 'customer',
  component: CustomerComponent,
  canActivate: [AuthGuardService],
  children: [
    { path: '', redirectTo: 'list', pathMatch: 'full' },
    { path: 'list', component: CustomerComponent },
    { path: 'all', component: CustomerComponent },
    { path: ':id', component: CustomerComponent },
  ]
},
{
  path: "product",
  component: ProductComponent,
  canActivate: [AuthGuardService]
},
{
  path: 'invoice',
  component: InvoiceComponent,
  //canActivate: [AuthGuardService],
  children: [
    { path: '', redirectTo: 'list', pathMatch: 'full' },
    { path: 'list', component: InvoiceComponent, canActivate: [AuthGuardService] },
    { path: 'downloadquote', component: InvoiceComponent },
    { path: ':customerId/:quoteId', component: InvoiceComponent,canActivate: [AuthGuardService] },
  ]
},
{
  path: "deliveryoption",
  component: DeliveryOptionComponent,
  canActivate: [AuthGuardService]
},
 {
   path: "customers/:id/quotes",
   component: QuoteComponent,
   canActivate:[AuthGuardService],
   data: { newCustomer: false }
 },
 {
   path: "quotes",
   component: QuoteComponent,
   canActivate:[AuthGuardService],
   data: { newCustomer: true },
 },

 {
   path: "login",
   component: LoginComponent,
 } 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
